import _indexOf from 'lodash.indexof';
import Vue from 'vue';

Vue.component('configurator-color-select', {
    props: {
        colors: {
            type: Array,
        },
        initialColor: {
            type: Object,
        },
    },

    data() {
        return {
            selectionExpanded: true,
            availableColors: [],
            color: null,
            colorExtraCost: '',
            colorExtraCostNotification: '',
            editionHandle: '',
            interiorHandles: [],
            isInteriorSelected: [],
            removedColor: false,
        };
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    watch: {
        /**
         * Send event on color change.
         *
         * @returns {Void}
         */
        color(value) {
            EventBus.$emit('configurator-set-color', value);
            this.trackColorSelection();
        },
    },
    beforeMount() {
        // This is hotfix for console error
        this.color = this.initialColor;
    },

    mounted() {
        // Set initial color.
        this.availableColors = this.colors;

        // Update color extra cost if a cost is emitted.
        EventBus.$on(
            'configurator-color-extra-cost',
            (extraCost, extraCostFormatted, showExtraCost, notification) => {
                this.colorExtraCost = '';
                this.colorExtraCostNotification = '';

                if (extraCost > 0 && showExtraCost) {
                    this.colorExtraCost = extraCostFormatted;

                    if (notification) {
                        this.colorExtraCostNotification = notification;
                    }
                }
            },
        );

        EventBus.$on('configurator-set-exclude-interior', (options) => {
            this.interiorHandles = [];
            this.isInteriorSelected = [];

            options.forEach((option) => {
                this.interiorHandles.push(option.field_optionHandle);
                this.isInteriorSelected.push(option.selected);
            });

            this.checkDisabledColors();
        });

        // Update editionHandle if edition changes.
        EventBus.$on('configurator-set-edition', (edition) => {
            this.editionHandle = edition.field_commerceHandle;
            this.updateAvailableColors();
        });
    },

    methods: {
        handleSetButtonStyle(colorOption) {
            return {
                backgroundColor: colorOption.colorCode,
                backgroundImage: 'url(' + colorOption.colorImageUrl + ')',
            };
        },

        handleSetButtonColor(colorOption) {
            const buttonColorStyles = [`color-${colorOption.colorSlug}`];
            if (this.color && this.color.colorSlug == colorOption.colorSlug) {
                buttonColorStyles.push('active');
            }

            return buttonColorStyles;
        },

        handleSetColor(colorOption) {
            this.color = colorOption;
        },

        checkDisabledColors() {
            this.availableColors = this.colors;
            this.updateAvailableColors();
            this.availableColors.forEach((color, colorIndex) => {
                if (color.field_disableInteriorColors_gqcddajo) {
                    const parsedColorsWithEditions = JSON.parse(
                        color.field_disableInteriorColors_gqcddajo,
                    );

                    let arrayColorsWithEditions = [];

                    parsedColorsWithEditions.forEach((colorWithEdition) => {
                        arrayColorsWithEditions.push(
                            Object.values(colorWithEdition),
                        );
                    });

                    arrayColorsWithEditions.forEach((colorWithEditions) => {
                        const colorWithEdition = colorWithEditions[0];
                        const disabledParts = colorWithEdition.split('-');

                        const disabledEdition = disabledParts[0];
                        const disabledColor = disabledParts[1];

                        if (
                            disabledEdition.toLowerCase() ==
                            this.editionHandle.toLowerCase()
                        ) {
                            this.interiorHandles.forEach((color, index) => {
                                if (!this.isInteriorSelected[index]) return;

                                if (disabledColor == color) {
                                    this.availableColors.splice(colorIndex, 1);
                                }
                            });
                        }
                    });
                }
            });
        },

        updateAvailableColors() {
            // Loop colors to check which are available.
            this.availableColors = [];
            const filteredColors = this.colors.filter(
                (color) =>
                    _indexOf(color.outOfStock, this.editionHandle) === -1,
            );
            this.availableColors = this.handleColorsForMG4(filteredColors);

            this.handleUnavailableColor(this.availableColors);
        },

        handleColorsForMG4(colorsArray) {
            if (colorsArray.length === 0) return [];
            if (this.editionHandle === 'xpower') return colorsArray;

            return colorsArray.filter(
                (color) => color.colorSlug !== 'hunter-green',
            );
        },

        handleUnavailableColor(colorsArray) {
            const isColorAvailable = Boolean(
                colorsArray.find(
                    (color) => this.color.colorSlug === color.colorSlug,
                ),
            );
            if (isColorAvailable) return;

            this.color = this.availableColors[0];
        },

        /**
         * Track model selection if any tracker who wants it is loaded.
         *
         * @return {Void}
         */
        trackColorSelection() {
            if (typeof p161 === 'object') {
                let pixelId = '';
                if (this.$parent.siteHandle === 'mgMotorsNetherlands') {
                    pixelId = '3161291';
                }
                if (this.$parent.siteHandle === 'mgMotorsNorway') {
                    pixelId = '3161320';
                }
                if (pixelId !== '') {
                    p161.track(pixelId, {
                        customer_extra:
                            this.$parent.model + '_' + this.color.colorSlug,
                    });
                    if (typeof window.trackQueue === 'function') {
                        window.trackQueue(p161);
                    }
                }
            }
        },
    },
});
